/**
 * Pricing Page - Page Shell
 * Piano tariffario
 */

import { PricingPanel } from "@/features/finanze";

export default function Pricing() {
  return <PricingPanel />;
}
